const Logo = require('../assets/images/logo_tm.png');
const dume = require('../../src/assets/images/logo9.jpg');

export { Logo,dume };